import { urlApi } from '@/utils/url';

export interface DidInfo {
    medio: string | null;
    producto: string | null;
}

export type DidsInfoMap = Record<string, DidInfo>;

export interface DidRow {
    did: string;
    medio: string | null;
    producto: string | null;
}

/**
 * Fetch medio/producto info for a batch of dids from the panel proxy
 * (which in turn queries Picallex API v2).
 *
 * Returns a map keyed by did: { "3584181596": { medio, producto } }.
 */
export default async function fetchDidsInfo(dids: string[]): Promise<DidsInfoMap> {
    if (!dids || dids.length === 0) {
        return {};
    }

    const url = `${urlApi}/dids/info`;
    const token = sessionStorage.getItem('token') || '';

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ dids }),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(`Error ${response.status}: ${JSON.stringify(data)}`);
    }

    return data as DidsInfoMap;
}
